'use strict';

var WOW = require('wow.js');

module.exports = {
    init: function() {
        new WOW().init();
    }
};



// WEBPACK FOOTER //
// ./modules/wow.js